import React, { Component } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import { compose } from 'redux';
import { Field, reduxForm, change, submit } from 'redux-form';
import Sticky from 'react-sticky-el';

import {
  loadProfile, updateProfile, uploadPhoto, createProfile,
  loadAgentProfile, updateAgentProfile, uploadAgentPhoto,
  loadCompanyProfiles
} from 'actions/profile';
import { ROOT_URL } from 'constants/Config';
import s from '../Profile.scss';
import Avatar from '../Avatar/Avatar';
import Social from '../Social';
import { setPopUp } from 'actions/environment';
import AvatarUploader from '../AvatarUploader';
import iconUser from 'assets/images/icons/icon-user-sq.svg';
import { normalizePhone } from './utils';
import Input from './Input';
import Textarea from './Textarea';
import validate from './validate';
import { withTranslation } from 'react-i18next';

class SaveButton extends Component {
  render() {
    // const { firstName, lastName, email, phone, position } = this.props
    const { t } = this.props;
    return (
      <button
        className={cn(s.ButtonSave, 'button-primary', 'button-primary--lg')}
        onClick={this.props.handleSaveClick}
      >
        {t('components.profile.profileForm.saveButton')}
      </button>
    );
  }
}

const ProfileFormSaveButton = connect(
  ({ form }) => (form.ProfileForm && form.ProfileForm.values) || {}
)(withTranslation()(SaveButton));

class Profile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      phones: 1,
      avatarId: props.avatarId
    };
  }

  UNSAFE_componentWillMount() {
    const { agentId } = this.props;
    if (agentId) {
      this.props.loadAgentProfile({ hash: agentId });
    } else {
      this.props.loadProfile({});
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.avatarId && nextProps.avatarId !== this.state.avatarId) {
      this.setState({ avatarId: nextProps.avatarId });
    }
  }

  handleAddPhoneClick = () => this.setState({ phones: this.state.phones + 1 });

  onLoadPhoto = ({ preview, file }) => {
    const { uploadPhoto, setPopUp, profileForm } = this.props;
    const { avatarId } = this.state;
    setPopUp(
      <AvatarUploader
        file={file}
        preview={preview}
        onSave={(file) => {
          const data = new FormData();
          data.append('file', file);
          setPopUp();

          this.props.uploadPhoto(data)
          .then((res) => {
            const avatarId = res.response.data.data.imageId;
            this.setState({ avatarId });
            // this.submitFormAsAdditionalData(avatarId);
          });
        }}
      />,
      { closeStyleName: 'Default', contentStyleName: 'Default', closeIcon: 'default', lockScroll: false });
  }

  onLoadHashPhoto = ({ preview, file }) => {
    const {
      uploadAgentPhoto, setPopUp, profileForm
    } = this.props;
    const { avatarId } = this.state;
    setPopUp(
      <AvatarUploader
        file={file}
        preview={preview}
        onSave={(file) => {
          const data = new FormData();
          data.append('file', file);
          setPopUp();

          this.props.uploadAgentPhoto(data)
          .then((res) => {
            const avatarId = res.response.data.data.imageId;
            this.setState({ avatarId });
            // this.submitFormAsAdditionalData(avatarId);
          });
        }}
      />,
      { closeStyleName: 'Default', contentStyleName: 'Default', closeIcon: 'default', lockScroll: false });
  }

  submitFormAsAdditionalData(avatarId) {
    const {
      isNew, agentId, agencyId, updateProfile, updateAgentProfile, createProfile, profileForm
    } = this.props;
    this.setState({ avatarId });

    const values = profileForm.values;

    if (isNew) {
      this.createAgentProfileWithUpdatingList({ ...values, avatarId, agencyId });
    } else if (agentId) {
      this.updateAgentProfileWithUpdatingList({ ...values, avatarId, userHash: agentId });
    } else {
      updateProfile({ ...values, avatarId });
    }
  }

  updateAgentProfileWithUpdatingList = async ({ userHash, avatarId, ...other }) => {
    await this.props.updateAgentProfile({ ...other, avatarId, userId: userHash });
    // FIXME: move it to redux
    this.props.loadCompanyProfiles({});
  }

  createAgentProfileWithUpdatingList = async ({ agencyId, avatarId, ...other }) => {
    await this.props.createProfile({ ...other, avatarId, agencyId, roleId: '13' });
    // FIXME: move it to redux
    this.props.loadCompanyProfiles({});
  }

  render() {
    const {
      handleSubmit, updateProfile, updateAgentProfile, createProfile,
      initialValues, agentId, isLoaded, isNew, agencyId, roleName, popup,
      onSave, t
    } = this.props;
    const { avatarId } = this.state;
    const hasPermission = (isNew || agentId || roleName === 'admin' || roleName === 'owner' || !agencyId);

    if ((isNew || (initialValues && isLoaded))) {
      return (
        <form
          onSubmit={handleSubmit(
          props => (isNew
            ? this.createAgentProfileWithUpdatingList({ ...props, avatarId, agencyId })
            : agentId
              ? this.updateAgentProfileWithUpdatingList({ ...props, avatarId, userHash: agentId })
              : updateProfile({ ...props, avatarId })
          ).then(() => { onSave && onSave(); })
        )}
          className={cn(s.Inner, { [s.PopupInner]: popup })}
        >
          <div className={cn(s.FormInner, { [s.PopupFormInner]: popup }, 'custom-scrollbar')}>
            <div className={s.AvatarWrapper}>

              <Avatar
                src={avatarId ? `${ROOT_URL}/image/get?id=${avatarId}&preset=avatar_edit` : iconUser}
                onLoadPhoto={agentId || isNew ? this.onLoadHashPhoto : this.onLoadPhoto}
                popup={popup}
              />
            </div>
            <div className={cn(s.Section, s.SectionInputs)}>
              <div className={s.InputWrap}>
                <Field
                  name="firstName"
                  component={Input}
                  label={t('components.profile.profileForm.firstName')}
                  placeholder={t('components.profile.profileForm.firstNameLabel')}
                  id="name"
                  required
                  disabled={!hasPermission}
                />
              </div>
              <div className={s.InputWrap}>
                <Field
                  name="lastName"
                  component={Input}
                  label={t('components.profile.profileForm.lastName')}
                  placeholder={t('components.profile.profileForm.lastNameLabel')}
                  id="surname"
                  required
                  disabled={!hasPermission}
                />
              </div>
              <div className={s.InputWrap}>
                <Field
                  name="phone"
                  component={Input}
                  type="tel"
                  label={t('components.profile.profileForm.saveButton')}
                  placeholder="+7"
                  mask="+\7 (111) 111-11-11"
                  id="phone"
                  required
                  disabled={!hasPermission}
                  normalize={normalizePhone}
                />
              </div>
              <div className={s.InputWrap}>
                <Field
                  name="email"
                  component={Input}
                  type="email"
                  label={t('components.profile.profileForm.email')}
                  placeholder="example@gmail.com"
                  id="email"
                  required
                  disabled={!hasPermission}
                />
              </div>
              <div className={s.InputWrap}>
                <Field
                  name="position"
                  component={Input}
                  label={t('components.profile.profileForm.position')}
                  placeholder={t('components.profile.profileForm.positionPlaceholder')}
                  id="position"
                  required
                  disabled={!hasPermission}
                />
              </div>
              {!isNew &&
              <div className={s.InputWrap}>
                <Field
                  name={agencyId ? 'agencyName' : 'company'}
                  component={Input}
                  label={t('components.profile.profileForm.company')}
                  placeholder={t('components.profile.profileForm.companyPlaceholder')}
                  required
                  disabled={!!agencyId}
                />
              </div>}
            </div>
            <div className={cn(s.Section, s.SectionTextarea)}>
              <Field
                name="description"
                component={Textarea}
                label={t('components.profile.profileForm.about')}
                placeholder={t('components.profile.profileForm.aboutPlaceholder')}
                id="description"
                maxLength={250}
              />
            </div>
            <div className={cn(s.Section, s.SectionSocial)}>
              <Social />
            </div>
          </div>
          {popup ?
            <ProfileFormSaveButton popup />
          :
            <Sticky mode="bottom" className={s.SaveButtonWrap} stickyClassName={s.SaveButtonWrapSticky}>
              <ProfileFormSaveButton popup />
            </Sticky>
        }
        </form>
      );
    }
    return null;
  }
}

const mapStateToProps = ({ profile, agentProfile, form }, { agentId, isNew }) => {
  const passProfile = agentId ? agentProfile : profile;

  const res = isNew ? {
    agencyId: passProfile && passProfile.agencyId
  } : {
    initialValues: undefined,
    avatarId: passProfile && passProfile.avatarId,
    isLoaded: passProfile && passProfile.isLoaded,
    agencyId: passProfile && passProfile.agencyId,
    roleName: passProfile && passProfile.roleName
  };
  if (!passProfile.isLoaded || (agentId && passProfile.id !== agentId)) {
    return {
      ...res,
      profileForm: form.ProfileForm
    };
  }
  return {
    ...res,
    initialValues: isNew ? {} : passProfile,
    profileForm: form.ProfileForm
  };
};

const mapDispatchToProps = {
  setPopUp,
  loadProfile,
  updateProfile,
  uploadPhoto,
  loadAgentProfile,
  updateAgentProfile,
  uploadAgentPhoto,
  createProfile,
  loadCompanyProfiles
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'ProfileForm',
    validate
  })
)(withTranslation()(Profile));



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileForm/ProfileForm.js